import { useEffect } from "react";
import { useSelector } from "react-redux";
import { selectPartner } from "../../Main/main.slice";
import { NewReceivedPaymentPopover } from "./NewReceivedPaymentPopover";
import { AccountReceivableHeader } from "./AccountReceivableHeader";
import { TableHeader } from "./TableHeader";
import TableFooter from "./TableFooter";
import { TableBody } from "./TableBody";
import { useAppDispatch } from "hooks/hooks";
import {
  getAllAccountReceivables,
  selectState,
  setPaymentCreationPopover,
} from "../accountReceivable.slice";
import Loader from "components/Loader/Loader";
import DeleteAccountReceivableModal from "./DeleteAccountReceivableModal";
import DeleteReceivedPaymentModal from "./DeleteReceivedPaymentModal";
import PopoverInvoice from "./PopoverInvoice";
import Popover from "components/Popover/Popover";
import { useProjectOptionsForReceivables } from "Dashboard/hooks/ProjectsOptions";

export const AccountReceivable = () => {
  const dispatch = useAppDispatch();
  const { loading, paymentCreationPopover } = useSelector(selectState);
  const partner = useSelector(selectPartner);
  const projects = useProjectOptionsForReceivables(partner?.partnerId);

  useEffect(() => {
    if (partner) {
      dispatch(getAllAccountReceivables(partner.partnerId));
    }
  }, [dispatch, partner?.partnerId]);

  return (
    <>
      <AccountReceivableHeader projects={projects} />
      <div className="table-holder loading-container">
        {loading && <Loader />}
        <TableHeader />
        <TableBody projects={projects} />
        <TableFooter />
      </div>
      <DeleteAccountReceivableModal />
      <DeleteReceivedPaymentModal />
      <PopoverInvoice />
      <Popover
        isOpen={paymentCreationPopover.isOpen}
        onClose={() => {
          dispatch(setPaymentCreationPopover({ isOpen: false }));
        }}
        direction="right"
        title="Mi potražujemo - plaćanje"
        arrowStyle={{ top: "40%" }}
        position={{
          top: paymentCreationPopover.top,
          left: paymentCreationPopover.left,
          offsetLeft: 20,
          offsetTop: -85,
        }}
      >
        <NewReceivedPaymentPopover />
      </Popover>
    </>
  );
};
